class TotangoJs {
  constructor() {
    window.totango_options = {
      service_id: 'SP-25205-01',
      user: {
        id: 'futuri',
      },
      // use the current page in the app as the Module name in Totango
      module: 'Webwidget',
    };
    const trackerName = window.totango_options.tracker_name || 'totango';
    window.totango_tmp_stack = [];
    window[trackerName] = { go() { return -1; }, setAccountAttributes() {}, identify() {}, track(t, o, n, a) { window.totango_tmp_stack.push({ activity: t, module: o, org: n, user: a }); return -1; } };
    const e = document.createElement('script');
    e.type = 'text/javascript';
    e.async = true;
    e.src = document.location.protocol === 'https:' ? 'https://tracker.totango.com/totango3.js' : 'http://tracker.totango.com/totango3.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(e, s);
  }

  trackStation(stationName) {
    const organization = `${stationName}__Post`;
    window.totango.track('Webwidget Loaded', 'Webwidget', organization, stationName);
  }
}

export default new TotangoJs();



// WEBPACK FOOTER //
// ./src/totango.js